import { useEffect } from "react";
import { useFeedbackFlowStore } from "../stores/feedback-flow-store";

export function useUnsavedChanges() {
	const isDirty = useFeedbackFlowStore((state) => state.isDirty);
	const isComplete = useFeedbackFlowStore((state) => state.isComplete);

	useEffect(() => {
		const handleBeforeUnload = (event: BeforeUnloadEvent) => {
			if (isDirty && !isComplete) {
				event.preventDefault();
				// Modern browsers require returnValue to be set
				event.returnValue = "";
				return "";
			}
		};

		window.addEventListener("beforeunload", handleBeforeUnload);

		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload);
		};
	}, [isDirty, isComplete]);
}
